<template lang="pug">
  v-dialog(v-model="dialogTerms" max-width="600px")
    v-card#dialogTermsCard
      v-card-text
        v-layout(wrap)
          v-flex.wrapper-btn-close(xs12 md12 lg12)
            div(style="cursor: pointer; position: absolute; top: 15px; right: 15px; z-index: 99;")
              img(:src="iconBtnClose" alt="iconBtnClose" @click="dialogTerms = false")
          v-flex.wrapper-title(xs12 md12 lg12)
            v-layout(wrap style="margin-top: 20px;")
              h3 Términos y condiciones
              p
                |
              p
                | A través de la presente solicitud autorizo pagar de manera recurrente, a mes adelantado, con cargo al medio de pago y la moneda elegida el valor de la prima de mi seguro de vida, conforme a lo señalado en las Condiciones Particulares. La afiliación tendrá efecto luego de que el Banco o la procesadora de la tarjeta de crédito/débito dé conformidad a la misma. El cobro de la(s) prima(s) podrá realizarse a partir del día 10 de cada mes, por lo que me comprometo a tener los fondos necesarios para que el cargo se realice en forma satisfactoria. De no tener éxito inicialmente, se reintentará el (los) cargo(s) de la(s) prima(s) impaga(s) durante el transcurso del mes.
              p
                | En caso estuviere atrasado en una o más primas y/o existiera algún préstamo, el cargo será por el total de las primas impagas, incluyendo aquellos gastos y/o intereses generados por dicho retraso y/o por los intereses del préstamo, respectivamente.
              p
                | Los cargos en la tarjeta de crédito/débito serán aplicados según la priorización definida por cada banco y se realizarán en la moneda que defina el cliente en la solicitud. De elegir la opción de cargo en nuevos soles, ya sea en tarjeta de crédito o en cuenta bancaria, el monto de la prima expresada en moneda extranjera se convertirá con el tipo de cambio vigente al momento de efectuar la transacción.
              p
                | En caso de reemplazo de la tarjeta por pérdida, robo, renovación o vencimiento, el Banco actualizará el nuevo número de tarjeta de crédito para poder continuar con el cargo automático. Sin perjuicio de ello, es obligación del Cliente informar a Interseguro el cambio del número de tarjeta.
              p
                | La presente instrucción expirará en forma automática en caso de caducidad del contrato con su Banco o con Interseguro.
              p
                | Interseguro carecerá de toda responsabilidad si el cargo de las primas no puede realizarse por insuficiencia de saldos o cualquier otro motivo no imputable a la compañía. Es responsabilidad del contratante verificar que los cargos de prima se realicen. La presente autorización deja sin efecto la vía de pago antes utilizada.
              p
                | En caso de que los datos ingresados de la tarjeta o cuenta no correspondan al Contratante, este declara haber obtenido los datos mencionados de manera lícita y contando con el consentimiento del tarjetahabiente o del titular de la cuenta.
</template>
<script>

export default {
  name: 'PaymentTermsConditions',
  data () {
    return {
      iconBtnClose: require('./../../assets/cambio-cobro/btn-close.svg'),
      dialogTerms: false
    }
  }
}
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/payment/PaymentTermsConditions.vue